/* eslint-disable max-len */
import React, { useState } from 'react';
import { Navbar, Sidebar } from '../../components';
import Authentication from './Authentication';
import SettingsTab from './Settings';
import TimeOff from './TimeOff';
import DesignationsTab from './designations';
import DepartmentsTab from './departments';
import WorkingHours from './WorkingHours';
import Projects from '../project/index';
import DataStorage from './DataStorage';
import ChartAbstraction from './ChartAbstraction';

// index -> { label, padded } ; padded tabs get inner padding, table/panel tabs manage their own.
const TABS = [
  { label: 'Settings', padded: true },
  { label: 'Permissions', padded: true },
  { label: 'Authentication', padded: true },
  { label: 'Data Storage', padded: true },
  { label: 'Time Off', padded: false },
  { label: 'Departments', padded: false },
  { label: 'Designations', padded: false },
  { label: 'Working Hours', padded: false },
  { label: 'Projects', padded: false },
  { label: 'Chart Abstraction', padded: true },
];

function Settings() {
  const [value, setValue] = useState(0);

  const renderPanel = () => {
    switch (value) {
      case 0: return <SettingsTab />;
      case 1: return <span className="text-sm text-ink-500">Permissions</span>;
      case 2: return <Authentication />;
      case 3: return <DataStorage />;
      case 4: return <TimeOff />;
      case 5: return <DepartmentsTab />;
      case 6: return <DesignationsTab />;
      case 7: return <WorkingHours />;
      case 8: return <Projects />;
      case 9: return <ChartAbstraction />;
      default: return null;
    }
  };

  return (
    <div>
      <Navbar />
      <Sidebar />
      <div className="screen-wrapper">
        <div className="screen-header" style={{ fontFamily: 'Inter, sans-serif' }}>
          {/* Header */}
          <div className="mb-5">
            <h1 className="font-bold text-ink-900 leading-tight text-2xl lg:text-[32px] lg:leading-10" data-testid="title" data-tour="settings">
              Settings &amp; Permissions
            </h1>
            <p className="text-sm text-ink-500 mt-1" data-testid="subtitle">
              Configure your workspace settings, policies, and member structure
            </p>
          </div>

          {/* Card with DS tab bar */}
          <div className="bg-white border border-rule rounded-[12px] overflow-hidden" style={{ borderStyle: 'solid', boxShadow: '0 1px 2px rgba(14, 30, 64, 0.04)' }}>
            <div className="flex items-center gap-1 px-3 overflow-x-auto border-b border-rule" style={{ borderBottomStyle: 'solid' }}>
              {TABS.map((t, i) => {
                const active = value === i;
                return (
                  <button
                    key={t.label}
                    type="button"
                    onClick={() => setValue(i)}
                    className={`relative inline-flex items-center px-4 py-3 text-sm bg-transparent border-0 cursor-pointer whitespace-nowrap transition ${active ? 'text-ink-900 font-semibold' : 'text-ink-500 font-medium hover:text-ink-900'}`}
                  >
                    {t.label}
                    {active && <span className="absolute left-2 right-2 bottom-0" style={{ height: 2, background: '#213d69', borderRadius: 2 }} />}
                  </button>
                );
              })}
            </div>
            <div style={{ padding: TABS[value]?.padded ? 24 : 0 }}>
              {renderPanel()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Settings;
